// index.js or main file
import React, { useState,useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import DDDUI from './pages/dddUI/ddd';
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/login/login';
import Polls from './pages/polls/polls';
import Admin from './admin/admin';
import ExportReports from './pages/polls/exportReport';


function usePageBackground() {
  const location = useLocation();


  useEffect(() => {
    const body = document.body;

    body.classList.remove('common-bg');

    switch (location.pathname) {
      case '/':
      case '/login':
        body.classList.add('common-bg');
        break;
      case '/polls':
        body.classList.add('common-bg');
        break;
        default:
        break;
    }
  }, [location]); 
}


function App() {
  usePageBackground();
  
  const navigate = useNavigate();

  // Get initial image from sessionStorage or env variable
  const getInitialImage = () => {
    return sessionStorage.getItem("orgData") || process.env.REACT_APP_EM_LOGO;
  };

  // State for header config
  const [headerConfig, setHeaderConfig] = useState({
    imageUrl: getInitialImage(),
    backButtonRedirect: "/", // Default back button
  });

  // Update both image and back button together (ONLY from Login)
  const updateHeader = ({ imageUrl, backButtonRedirect }) => {
    setHeaderConfig((prev) => ({
      imageUrl: imageUrl || prev.imageUrl, // Only update if provided
      backButtonRedirect: backButtonRedirect || prev.backButtonRedirect, // Only update if provided
    }));

    // Store image in sessionStorage if provided
    if (imageUrl) sessionStorage.setItem("orgData", imageUrl);
  };


  const handleBack = () => {
    const { backButtonRedirect } = headerConfig;

    if (backButtonRedirect.length > 20) {
      // Open in new tab (External Link)
      window.location.href = backButtonRedirect;
    } else {
      // Internal Navigation
      navigate(backButtonRedirect);
    }
  };

  return (
    <DDDUI imageUrl={headerConfig.imageUrl} onBack={handleBack}>
      <Routes>
        <Route path="/" element={<Login updateHeader={updateHeader} />} />
        <Route path="/polls" element={<Polls updateHeader={updateHeader} />} />
        <Route path="/exportReport/:sessionId/:themeId" element={<ExportReports/>} />
        <Route path="/login" element={<Login updateHeader={updateHeader} />} />
        <Route path="/admin" element={<Admin/>} />
      </Routes>
    </DDDUI>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
